import * as React from "react";

const SvgIcnDataBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M6 8h2a1 1 0 011 1v10a1 1 0 01-1 1H6a1 1 0 01-1-1V9a1 1 0 011-1zm5 4h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6a1 1 0 011-1zm5-8h2a1 1 0 011 1v14a1 1 0 01-1 1h-2a1 1 0 01-1-1V5a1 1 0 011-1z"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            strokeWidth={1}
        />
    </svg>
);

export default SvgIcnDataBold;
